"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSilentLogin = void 0;
/**
 * Adds the event listener for the successful silent authentication
 * Passed callback function will be invoked when the successful silent
 * login post message is received.
 *
 * Returns the cleanup function to remove the event listener
 */
function onSilentLogin(successCallback, errorCallback) {
    const handleSilentLogin = (event) => {
        try {
            const messageData = event.data;
            // Keep in sync with the ID we send here: src/authRoutes/utils/silentAuthCompleteRes.html
            if (messageData) {
                if (messageData.kind === "@tenx/silent-login-success") {
                    successCallback();
                }
                if (messageData.kind === "@tenx/silent-login-error") {
                    errorCallback();
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    window.addEventListener("message", handleSilentLogin);
    // Return cleanup
    return () => window.removeEventListener("message", handleSilentLogin);
}
exports.onSilentLogin = onSilentLogin;
